import Modal from "../Modal/Modal";
import { Container, MainButton } from "./ConfirmationModalStyles";

interface IConfirmationModal {
  title: string;
  message: string | string[];
  onAccept: () => void;
  toggleModal: () => void;
  zIndex?: any;
}
function ConfirmationModal(props: IConfirmationModal) {
  const { title, message, onAccept, toggleModal, zIndex } = props;

  const messages = Array.isArray(message) ? message : [message];

  return (
    <Modal
      zIndex={zIndex}
      onOutsideClick={() => {
        toggleModal();
      }}
    >
      <Container>
        <h1>{title}</h1>
        {messages.map((message, i) => {
          return <p key={i}>{message}</p>;
        })}
        <MainButton
          onClick={() => {
            onAccept();
          }}
        >
          Entendido
        </MainButton>
      </Container>
    </Modal>
  );
}
export default ConfirmationModal;
